import { render } from "./page.detail.editor.pane.vue?vue&type=template&id=30a7fe5f"
import script from "./page.detail.editor.pane.vue?vue&type=script&lang=js"
export * from "./page.detail.editor.pane.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__